<template>
  <div
    class="web-develop"
    :style="{
      backgroundImage: 'url(' + dataInfo.cover + ')'
    }"
  >
    <div class="g-box">
      <div class="develop-title">
        <div class="tt">development history</div>
        <div class="tit">发展历程</div>
      </div>
    </div>
    <div style="overflow: hidden;">
      <vue-seamless-scroll
        style="width:100%"
        :data="contentData"
        :class-option="classOption2"
      >
        <div class="develop-items">
          <div
            class="item"
            :class="i % 2 ? 'reverse' : ''"
            v-for="(item, i) in contentData"
            :key="i"
          >
            <div class="item-year">{{ item.year }}</div>
            <div class="item-text">
              {{ item.content }}
            </div>
          </div>
        </div>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      classOption2: {
        limitMoveNum: 1,
        step: 1.5,
        direction: 2,
        hoverStop: false
      },
      contentInfo: {},
      contentData: [],
      banner: {}
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: { vueSeamlessScroll },
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 1,
      menuId: this.menuId
    });
    this.contentInfo = data[0];
    this.dataInfo = dataInfo;
    this.contentData = JSON.parse(this.contentInfo.content);
  },
  methods: {
    toDetail() {
      this.toUrl(this.contentInfo.url);
    }
  }
};
</script>
<style lang="less">
.web-develop {
  padding-top: 111px;
  width: 100%;
  height: 970px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-sizing: border-box;
  .develop-title {
    .tt {
      font-size: 60px;
      font-family: "en-tit";
      line-height: 72px;
      color: rgba(255, 255, 255, 0);
      -webkit-text-stroke: 1px #fff;
      text-transform: uppercase;
      text-stroke: 1px #fff;
    }
    .tit {
      font-size: 40px;
      font-family: Dream-LiHeiGB, Dream;
      color: #fff;
      line-height: 45px;
    }
  }
  .develop-items {
    display: flex;
    margin-top: 90px;
    .item {
      padding-left: 32px;
      margin-right: 10px;

      width: 254px;
      height: 292px;
      background-image: url("../../../assets/img/icon-top.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      box-sizing: border-box;
      &-year {
        font-size: 28px;
        font-weight: bold;
        color: #fff;
        line-height: 32px;
      }
      &-text {
        padding-top: 18px;
        width: 120%;
        font-size: 14px;
        color: #fff;
        line-height: 20px;
      }
    }
    .item.reverse {
      margin-top: 150px;
      margin-left: 10px;
      height: 369px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      background-image: url("../../../assets/img/icon-bot.png");
    }
  }
}
</style>
